'use client';

import { Button, ButtonProps } from '@components/button';
import { useCallback } from 'react';

import { sendSberAdsEvent } from '@/shared/utils/sendSberAdsEvent';
import smoothScroll from '@/shared/utils/smoothScroll';

export const ScrollToFormButton = (props: ButtonProps) => {
  const handleClick = useCallback(() => {
    smoothScroll('form');
    sendSberAdsEvent('click-to-form');
  }, []);

  return <Button onClick={handleClick} {...props} />;
};
